// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApplicantTypeController from "./applicant_type_controller"
application.register("applicant-type", ApplicantTypeController)

import BookingCalcController from "./booking_calc_controller"
application.register("booking-calc", BookingCalcController)

import CaptchaController from "./captcha_controller"
application.register("captcha", CaptchaController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import PaymentFormController from "./payment_form_controller"
application.register("payment-form", PaymentFormController)

import PropertyMapController from "./property_map_controller"
application.register("property-map", PropertyMapController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
